<template>
	<b-modal
		:visible="show"
		:ok-disabled="loadingSubmit"
		:cancel-disabled="loadingSubmit"
		:hide-footer="loading"
		@hidden="close"
		@ok="submit"
		:ok-title="'disableStudent.modal.btnSubmit' | translate"
		:cancel-title="'disableStudent.modal.btnCancel' | translate"
		:title="'disableStudent.modal.title' | translate"
	>
		<div v-if="loading" class="loader"><loader /></div>
		<form v-else @submit.prevent="submit" class="modal-block">
			<p>
				{{ 'disableStudent.modal.description' | translate }}
				<router-link
					:to="{
						name: 'Dashboard Student Main',
						query: { read_only: profile.id, from: 'Dashboard List' },
					}"
					target="_blank"
					><b>{{ profile.last_name }} {{ profile.first_name }}</b></router-link
				>
			</p>
			<label>{{ 'disableStudent.modal.fieldLabel' | translate }}</label>
			<select class="form-control mb-2" v-model.number="month">
				<option value="5">{{ 'May' | translate }}</option>
				<option value="6">{{ 'June' | translate }}</option>
				<option value="7">{{ 'July' | translate }}</option>
				<option value="8">{{ 'August' | translate }}</option>
			</select>
			<p v-if="error" class="text-danger">{{ error }}</p>
		</form>
	</b-modal>
</template>

<script>
import Loader from '@/components/Loader'
export default {
	name: 'modal-disable-student',
	components: {
		Loader,
	},
	data: () => ({
		month: 8,
		loading: false,
		loadingSubmit: false,
		error: '',
		profile: {},
	}),
	props: ['show', 'id'],
	watch: {
		id() {
			if (this.id) {
				this.requestProfileData()
			}
		},
		show() {
			this.month = 8
			this.error = ''
			this.loading = false
			this.loadingSubmit = false
			this.profile = false
		},
	},
	created() {
		if (this.id) {
			this.requestProfileData()
		}
	},
	methods: {
		submit(e) {
			if (e) e.preventDefault()
			this.loadingSubmit = true
			this.axios({
				url: `users/user/${this.id}/set_deactivation_date`,
				method: 'post',
				data: {
					month: this.month,
				},
			})
				.then(({ data }) => {
					this.loadingSubmit = false
					this.$emit('onSuccess')
					this.close()
				})
				.catch(error => {
					const response = error.response.data.detail
					this.loadingSubmit = false

					if (response && response.non_field_errors) {
						this.error = response.non_field_errors.join('\n')
					} else {
						this.error = 'Error has occurred'
					}
				})
		},
		close() {
			this.$emit('close')
		},
		requestProfileData() {
			this.loading = true
			this.axios({
				url: `users/user/${this.id}`,
			})
				.then(({ data }) => {
					this.profile = data
					this.loading = false
				})
				.catch(() => {
					this.loading = false
				})
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button:not(.close) {
	margin: 10px;
}

.loader svg {
	display: block;
	margin: auto;
	width: 100px;
	height: 100px;
}
</style>
